// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__AsOpp","content":"styles_content__2I1yD","selectAll":"styles_selectAll__1epcb"};